module.exports = __webpack_public_path__ + "static/media/text.8600f23d.svg";